import {createContext} from 'react';

const listaPilotosContext = createContext();

export default listaPilotosContext;